import { ASChartVBar, ASChartVBarProps } from '@eleventheye/asui';
import { getTeamColorsByTeamId } from 'helpers/TeamHelpers';
import React from 'react';

type TeamVerticalChartProps = {
  teamId: number;
} & ASChartVBarProps;

const TeamVerticalChart: React.FC<TeamVerticalChartProps> = ({ teamId, ...props }) => {
  const teamColors = getTeamColorsByTeamId(teamId);
  return (
    <ASChartVBar
      {...props}
      primaryColor={teamColors.primary}
      secondaryColor={teamColors.secondary}
      direction="up"
      withShadow
    />
  );
};

export default TeamVerticalChart;
